export * from './blogPostsList';
export * from './categoriesList';

export const findComponentOnPage = (name, pageData = []) => pageData.find((c) => (c.name || '').includes(name));
